/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Watch_BodyInputs */

const en_features_watch_body = /** @type {(inputs: Features_Watch_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are building an Apple Watch app: who comes next, when and for what, without reaching for your phone between sessions.`)
};

const pl_features_watch_body = /** @type {(inputs: Features_Watch_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracujemy nad aplikacją na Apple Watch: kto przychodzi, o której i na co, bez sięgania po telefon między treningami.`)
};

/**
* | output |
* | --- |
* | "We are building an Apple Watch app: who comes next, when and for what, without reaching for your phone between sessions." |
*
* @param {Features_Watch_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_watch_body = /** @type {((inputs?: Features_Watch_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Watch_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_watch_body(inputs)
	return en_features_watch_body(inputs)
});